<style lang="scss" scoped>
  @import "./side-bar";
</style>

<script>

export default {
  data () {
    return {
      trace: false,
      currentRoutePath: ''
    }
  },

  watch: {
    $route () {
      this.currentRoutePath = this.$router.currentRoute.path
    }
  },

  created () {
    this.currentRoutePath = this.$router.currentRoute.path
  },

  methods: {
    configurationPage () {
      this.$router.push('/configuration/checkout').catch(err => { console.error(err) })
    }
  }
}

</script>
<template>
  <div>
    <div
      v-if="!currentRoutePath.includes('configuration')"
      id="quick-config"
      class="quick-config-btn side-button"
      data-test="trace-page"
      @click="$emit('openConfig')"
    >
      <i class="fa fa-cog" />
      <span class="icon-desc ml-1">Quick Configuration</span>
    </div>
    <div
      id="configuration-page"
      class="setting-btn side-button"
      data-test="configuration-page"
      @click="configurationPage()"
    >
      <i class="fa fa-cogs" />
      <span class="icon-desc ml-1">Detail Configuration</span>
    </div>
    <div
      id="trace-log"
      class="trace-btn side-button"
      data-test="trace-page"
      @click="$emit('openTrace')"
    >
      <i class="fa fa-code" />
      <span class="icon-desc ml-1">API Logs</span>
    </div>
  </div>
</template>
